import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import TrbmData from "./data/trbm.json";
import FooterLinks from "@tightrope/footerlinks/footer.js";
import Styles from "./css/trbm.module.scss";
import { isChrome, isFirefox, isIeEdge, getBrowser } from "@tightrope/lpscripts/browserdetect";
let Trbm = /*#__PURE__*/function (_React$Component) {
  function Trbm(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isChrome: isChrome(),
      isFirefox: isFirefox(),
      isIeEdge: isIeEdge(),
      display: 'none',
      pageData: props.data,
      data: TrbmData
    };
    return _this;
  }
  _inheritsLoose(Trbm, _React$Component);
  var _proto = Trbm.prototype;
  _proto.showBrowsers = function showBrowsers(browsers) {
    let display = false;
    if (getBrowser() === 'ie' && browsers.includes('ie')) {
      display = true;
    }
    if (getBrowser() === 'firefox' && browsers.includes('firefox')) {
      display = true;
    }
    if (getBrowser() === 'chrome' && browsers.includes('chrome')) {
      display = true;
    }
    if (getBrowser() === 'edge' && browsers.includes('edge')) {
      display = true;
    }
    if (getBrowser() === 'other' && browsers.includes('other')) {
      display = true;
    }
    if (display) this.setState({
      display: 'block'
    });else this.setState({
      display: 'none'
    });
  };
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.browsers) {
      this.showBrowsers(this.props.browsers);
    } else {
      this.setState({
        display: 'block'
      });
    }
    this.props.data.then(data => {
      const instanceData = Object.assign(this.state.data, data);
      this.setState({
        data: instanceData
      });
      this.state.isChrome = isChrome();
      this.state.isFirefox = isFirefox();
      this.state.isIeEdge = isIeEdge();
      if (isChrome()) {
        const browserData = Object.assign(this.state.data, this.state.data.chrome);
        this.setState({
          data: browserData
        });
      }
      if (isFirefox()) {
        const browserData = Object.assign(this.state.data, this.state.data.firefox);
        this.setState({
          data: browserData
        });
      }
    });
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: Styles.trbm,
      style: {
        display: this.state.display
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: Styles.bmlpwrap
    }, /*#__PURE__*/React.createElement("div", {
      className: Styles.card
    }, /*#__PURE__*/React.createElement("div", {
      className: Styles.wrap
    }, /*#__PURE__*/React.createElement("img", {
      className: Styles.logo,
      src: this.state.data.logo
    }), /*#__PURE__*/React.createElement("h1", {
      className: "hc_param"
    }, this.state.data.headline), /*#__PURE__*/React.createElement("h2", null, this.state.data.subhead), /*#__PURE__*/React.createElement("ul", {
      className: Styles.bullets
    }, this.state.data.bullets != undefined ? this.state.data.bullets.map((bullet, i) => {
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        dangerouslySetInnerHTML: {
          __html: bullet
        }
      });
    }) : null), /*#__PURE__*/React.createElement("button", {
      className: "cl1 " + Styles.trbm_cta + " " + Styles.cl1,
      "data-cy": "cta",
      onClick: () => window.triggerInstall(),
      dangerouslySetInnerHTML: {
        __html: this.state.data.mainCTA
      }
    }), this.props.children)), /*#__PURE__*/React.createElement("div", {
      className: Styles.steps
    }, /*#__PURE__*/React.createElement("img", {
      src: "/img/steps-arrow-dark.png"
    }), /*#__PURE__*/React.createElement("div", {
      className: Styles.step + " " + Styles.step1
    }, /*#__PURE__*/React.createElement("strong", null, "Step1"), /*#__PURE__*/React.createElement("br", null), "Click", /*#__PURE__*/React.createElement("br", null), "Continue"), /*#__PURE__*/React.createElement("div", {
      className: Styles.step + " " + Styles.step2
    }, /*#__PURE__*/React.createElement("strong", null, "Step2"), /*#__PURE__*/React.createElement("br", null), "Click", /*#__PURE__*/React.createElement("br", null), "Add to ", isChrome() ? /*#__PURE__*/React.createElement("span", {
      className: Styles.chromeonly
    }, "Chrome") : null, " ", isFirefox() ? /*#__PURE__*/React.createElement("span", {
      className: Styles.firefoxonly
    }, "Firefox") : null), /*#__PURE__*/React.createElement("div", {
      className: Styles.step + " " + Styles.step3
    }, /*#__PURE__*/React.createElement("strong", null, "Step3"), /*#__PURE__*/React.createElement("br", null), "Start ", /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: this.state.data.productName
      }
    })))), /*#__PURE__*/React.createElement(FooterLinks, null));
  };
  return Trbm;
}(React.Component);
export default Trbm;